module.exports = __webpack_public_path__ + "static/media/rabbit.b8f08d51.svg";